import React from 'react';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import {
  ColorPicker,
  Controls,
  InlineControl,
  LabeledControl,
  Header,
  Selection,
  Section,
  Slider,
  SubHeader,
  TextFormat,
  ToggleGroup,
  ToggleOption,
  BackgroundColorControl,
} from '../../../reporting/sidebar/components';
import ChartTitle from '../ChartTitle';

function MainConfig() {
  const { get } = useReportConfiguration();

  return (
    <Section defaultOpen>
      <Header>Chart</Header>
      <ChartTitle />
      <SubHeader>Style</SubHeader>
      <Controls>
        <LabeledControl title='Type'>
          <ToggleGroup configurationKey='layout'>
            <ToggleOption value='pie'>
              <i className='fa-solid fa-chart-pie' /> Pie
            </ToggleOption>
            <ToggleOption value='donut'>
              <i
                style={{ fontSize: 12 }}
                className='aha-icon aha-icon-doughnut'
              />{' '}
              Donut
            </ToggleOption>
          </ToggleGroup>
        </LabeledControl>

        <BackgroundColorControl />

        <LabeledControl title='Border'>
          <ColorPicker
            configurationKey='border_color'
            options={{ noFill: 'Clear color' }}
          />
        </LabeledControl>

        <LabeledControl title='Data counts'>
          <Selection
            configurationKey='showLabels'
            options={[
              ['On', true],
              ['Off', false],
            ]}
          />
        </LabeledControl>

        <LabeledControl title='Slice'>
          <Selection
            configurationKey='sliceData'
            options={[
              ['Value', 'value'],
              ['Percentage', 'percentage'],
            ]}
            disabled={get('seriesLabels') === 'inside' || !get('showLabels')}
          />
        </LabeledControl>

        <LabeledControl title='Labels'>
          <Selection
            configurationKey='seriesLabels'
            options={[
              ['Outside', 'outside'],
              ['Inside', 'inside'],
              ['None', null],
            ]}
          />
        </LabeledControl>

        <LabeledControl title='Radius' alignTop>
          <Slider
            configurationKey='radius'
            props={{ min: 5, max: 95, step: 1, labeled: 'below' }}
            disabled={!(get('layout') === 'donut')}
          />
        </LabeledControl>
        <LabeledControl title='Data labels' />
        <InlineControl>
          <TextFormat
            configurationKey='dataLabelFormat'
            defaultSize={12}
            defaultColor='black'
            defaultFontWeight='normal'
            defaultFontStyle='normal'
          />
        </InlineControl>
      </Controls>
    </Section>
  );
}
export default MainConfig;
